import * as t from 'io-ts'
import { TransactionType } from '../TransactionType'
import { SourceType } from '../SourceType'
import { Maybe } from '@mxt/zio/codec'

const Base = <C extends t.Mixed>(codec: C) =>
  t.intersection([
    t.type({
      transactionType: t.literal(TransactionType.SCHEDULED_PAYMENT_STATEMENT)
    }),
    codec
  ])

const Pulse4Ops = Base(
  t.type({
    source: t.literal(SourceType.PULSE4OPS),
    payload: t.type({
      body: t.type({
        fromDate: Maybe(t.string),
        toDate: Maybe(t.string)
      })
    })
  })
)

export const ScheduledPaymentStatement = Pulse4Ops
export type ScheduledPaymentStatement = t.TypeOf<typeof ScheduledPaymentStatement>
